import { Environment } from './environment.interface';

export const environment: Environment = {
  abn: {
    apiUrl: 'https://superfundlookup.gov.au/xmlsearch/SflXmlSearch.asmx/SearchByABN2015',
    guid: '1eef3e15-ea20-4b38-a6d5-f6f71ce069de'
  },
  recaptcha_api_string: '6Le9xOEnAAAAAE93MmlaS2KyTqGagFY5fMCwOdse',
  teamSalaryBackendUrl: 'https://dev-team.woolworths.com.au/api',
  bsbUrl: 'https://uat.mobile-api.woolworths.com.au/api-wow-winter/verify/bsb',
  bsbApi_string: 'AG9bO1coxhmGGuXNdJIISFMyqfTTwCsJ',
  production: false,
  googleClientId: '614512994682-q8oebrbrtpmmurlnc958jd8ole4igi37.apps.googleusercontent.com',
  contentful: {
    spaceId: '3h8j9vctv5nr',
    environment: 'test',
    api_string: '9vX6mnC7MKlnQyYXSh-7Atn_LS-HclOpIVQwLdQXP-c',
  },
  googleMapsApi_string: 'AIzaSyAaQVakyIL1YI9eRgOpkFYEnvPgMWQCe-M'
};
